import React from 'react'
import PropTypes from 'prop-types'
import { Link as GatsbyLink, navigate as gatsbyNavigate } from 'gatsby'
import {
  createLocaleSlug,
  createEnLocaleSlug,
} from '@crunchyroll/cr-static-shared-components'

import { IntlContextConsumer } from './intl-context'
import intlOptions from '../config'

const { pathPrefix, languages, isClientPage } = intlOptions

export const withPrefix = (url) => {
  const prefix = process.env.NODE_ENV === 'production' ? pathPrefix : ''
  return `${prefix}${url}`
}

const Link = ({ to, language, children, onClick, ...rest }) => (
  <IntlContextConsumer>
    {(intl) => {
      const languageLink = language || intl.language
      const link =
        intl.routed || language
          ? `/${languageLink}${pathPrefix}${to}`
          : withPrefix(to)

      const handleClick = (e) => {
        if (language) {
          localStorage.setItem('gatsby-intl-language', language)
        }
        if (onClick) {
          onClick(e)
        }
      }

      return (
        <GatsbyLink {...rest} to={link} onClick={handleClick}>
          {children}
        </GatsbyLink>
      )
    }}
  </IntlContextConsumer>
)

Link.propTypes = {
  children: PropTypes.node.isRequired,
  to: PropTypes.string,
  language: PropTypes.string,
}

Link.defaultProps = {
  to: '',
}

export default Link

export const navigate = (to, options) => {
  if (typeof window === 'undefined') {
    return
  }

  const { language, routed } = window.___gatsbyIntl
  const link = routed ? `/${language}${pathPrefix}${to}` : withPrefix(to)
  gatsbyNavigate(link, options)
}

export const changeLocale = (language, to) => {
  if (typeof window === 'undefined') {
    return
  }

  const { routed } = window.___gatsbyIntl
  const pathname = window.location.pathname
  const env = process.env.NODE_ENV

  const slug = createLocaleSlug({
    routed,
    isClientPage,
    pathname,
    env,
    pathPrefix,
    languages,
  })

  const enSlug = createEnLocaleSlug({ slug, isClientPage, env, pathPrefix })

  const link =
    language !== 'en'
      ? `/${language}${pathPrefix}${slug}${window.location.search}`
      : withPrefix(`${enSlug}${window.location.search}`)

  localStorage.setItem('gatsby-intl-language', language)
  window.location.assign(link)
}
